export var positionEnum;

(function (positionEnum) {
  positionEnum["left"] = "left";
  positionEnum["right"] = "right";
})(positionEnum || (positionEnum = {}));